import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '../mui/Core/index'
import CompanyLogo from '../../assets/images/company-logo.svg'

function FormHeading({ formHeader }) {
  const headerContainerStyle = { marginTop: '20px' }
  const companyLogoContainerStyle = { width: 152 }
  const companyLogoStyle = { width: '100%', height: '100%' }

  return (
    <>
      <Box sx={companyLogoContainerStyle}>
        <img alt='companyLogo' src={CompanyLogo} style={companyLogoStyle} />
      </Box>
      <Box sx={headerContainerStyle}>
        <Typography data-testid='form-heading-title' variant='cardHeader' gutterBottom>
          {formHeader}
        </Typography>
      </Box>
    </>
  )
}

FormHeading.propTypes = {
  formHeader: PropTypes.string,
}

export default FormHeading
